import React, { Component } from "react";
import "../Styles/Home.css";

export default class Home extends Component {
  render() {
    return (
      <div className="Home animate__animated animate__slideInLeft">
        <h3 className="animate__animated animate__slideInLeft ">
          Welcome To Our Cracking Pad!
        </h3>
        <div>
          <h4 className="animate__animated animate__slideInLeft ">
            Introducion
          </h4>
          <p className="animate__animated animate__fadeIn animate__delay-1s ">
            This project provides a cracking simulator online for {" "}
            <a
              rel="noopener noreferrer"
              target="_blank"
              href="https://multitheftauto.com/"
            >
              MTA:SA
            </a>{" "}
            players, The Cracking Pad is a minigame used on multiple gamemodes
            that consists of having a max number and going through lower and
            higher numbers till you guess it.
          </p>
        </div>
        <div>
          <h4 className="animate__animated animate__slideInLeft ">Credits & Support:</h4>
          <p className="animate__animated animate__fadeIn animate__delay-1s ">
            This Project was developped by FilexGH
          </p>
        </div>
        <div>
          <h4 className="animate__animated animate__slideInLeft ">Modes:</h4>
          <p className="animate__animated animate__fadeIn animate__delay-1s ">
            Classic: The mode allows the user to set a max and start to guess a random number in this max interval.
            <br/>
            Solo: The mode simulates the bank robbery system in SAES:RPG server, with 3 doors and 8 safes to crack.
            <br/>
            Infinity: This mode allows the user to set an increase rate in the max and crack without limits
          </p>
        </div>
        <br/>
        <p><i>Note: if the touch pad shows too be small or too big, please use the zoom feature on your browser.</i></p>
      </div>
    );
  }
}
